import { HashLink } from 'react-router-hash-link';
import email from "../../../assets/img/email.png";
import phone from "../../../assets/img/phone.png";
import location from "../../../assets/img/location.png";
import whatsapp from "../../../assets/img/whatsapp.png";
import up from "../../../assets/img/up.png";
import style from "./Footer.module.css";

const Footer = ({isMobile}) => {

    return(
        <div className={style.footer}>
            {isMobile ? 
                <div className={style.footerContent}>
                    <a href="https://api.whatsapp.com/send?phone=5492216954484" target="_blank" rel="noopener noreferrer" className={style.whatsappLinkMobile}><img src={whatsapp} alt="Comunicarse por WhatsApp"/></a>
                </div>
            :
                <div className={style.footerContent}>
                    <div className={style.left}>
                        <ul>
                            <li><a href="mailto:ventas.electroplat@gmail.com" target="_blank" rel="noopener noreferrer"><img src={email} alt="Email"/>ventas.electroplat@gmail.com</a></li>
                            <li><a href="tel:+542214514239" target="_blank" rel="noopener noreferrer"><img src={phone} alt="Teléfono"/>(0221) 451-4239</a></li>
                        </ul>
                    </div>
                    <div className={style.center}>
                        <a href="https://www.google.com/maps/place/Electroplat/@-34.9337936,-57.9706558,17z/data=!3m1!4b1!4m6!3m5!1s0x95a2e794c9cb8b53:0x164a5857ac897ad1!8m2!3d-34.9337936!4d-57.9706558!16s%2Fg%2F1tfn3xwz?entry=ttu&g_ep=EgoyMDI1MDgxMy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                            <img src={location} alt="Ubicación"/>
                            <p>Calle 50 n° 1615 e/ 27 y 28, La Plata</p>
                        </a>
                    </div>
                    <div className={style.right}>
                        <a href="https://api.whatsapp.com/send?phone=5492216954484" target="_blank" rel="noopener noreferrer" className={style.whatsappLink}><img src={whatsapp} alt="Comunicarse por WhatsApp"/><p>¡Dejanos tu consulta!</p></a>
                        <HashLink smooth to="/#top"><img src={up} alt="Arriba"/></HashLink>
                    </div>
                </div>
            }

        </div>
    );
};

export default Footer;